import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The iPhone Catch-up sort deck gate (docs/plans/2026-10-31-feat-ios-catch-up-v2-plan.md, decision 1), spread
 * into FEATURE_GATE_SEEDS in feature-gate-registry.ts at its place in the admin page order. The row is
 * created by the catch_up_v2_feature_gate migration.
 */
export const CATCH_UP_FEATURE_GATE_SEEDS = {
  catch_up_v2: {
    label: 'Catch-up: sort, then do',
    shortLabel: 'Catch-up v2',
    description:
      "On the iPhone, Catch-up's Start opens a sort deck: every card in turn, swiped to Do now, Later, Schedule or Delegate, then the Do now queue worked one card at a time. Not a sidebar item - off, Start opens the budgeted session as before.",
    group: 'correspondence',
  },
} satisfies Record<string, FeatureGateSeed>;
